import React from 'react';
import { CHIPOTLE_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';
import EcoSection from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/eco-section';
import usePermissionsChecker from 'helpers/hooks/usePermissionsChecker';

interface Props {
  data: any;
  customerGroup: any;
}

const EcoSectionTastic: React.FC<Props> = ({ data, customerGroup }) => {
  if (!data) {
    return <div>Loading...</div>;
  }

  const { getFields, filterByTags, checkItemPermission } = usePermissionsChecker();

  const dataSourceItems = data?.data?.dataSource?.items?.[0];

  const hasParentPermission = checkItemPermission(dataSourceItems, customerGroup);

  if (!hasParentPermission) {
    return <></>;
  }

  const dataSourceFields = dataSourceItems?.fields;
  const miniCards = filterByTags(dataSourceFields?.miniCards, customerGroup)?.map(getFields) ?? [];

  const titleFields = checkItemPermission(dataSourceFields?.title, customerGroup)
    ? getFields(dataSourceFields?.title)
    : {};
  const titleInfo = {
    ...titleFields,
    titleFontSize: titleFields?.titleFontSize || '1x',
    subtitleFontSize: titleFields?.subtitleFontSize || '1x',
  };
  const tileInfo = checkItemPermission(dataSourceFields?.tile, customerGroup) ? getFields(dataSourceFields?.tile) : {};

  const textTileFields = getFields(dataSourceFields?.textTile);
  const textTileInfo = {
    icon: textTileFields?.mainIcon?.fields?.file?.url,
    mainText: textTileFields?.mainText,
    ctaText: textTileFields?.ctaLabel,
    ctaReference: textTileFields?.ctaReference,
    resultsEco: filterByTags(textTileFields?.resultsEco, customerGroup)?.map((res: any) => ({
      icon: res?.fields?.icon?.fields?.file?.url,
      leftText: res?.fields?.leftText,
      rightText: res?.fields?.rightText,
    })),
    tileContent: checkItemPermission(textTileFields?.tile, customerGroup) ? getFields(textTileFields?.tile) : {},
  };

  const ecoData = {
    titleInfo,
    miniCards,
    tileInfo,
    textTileInfo,
  };

  return <EcoSection {...ecoData} look={CHIPOTLE_CONTENT_LOOK} />;
};

export default EcoSectionTastic;
